<svg fill="none" height="21" viewBox="0 0 21 24" width="21" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M18 16.6286V10.4571C18 6.68571 15.8571 3.51429 12.1714 2.65714V1.8C12.2571 0.857143 11.3143 0 10.2857 0C9.25714 0 
    8.4 0.857143 8.4 1.88571V2.74286C4.62857 3.51429 2.57143 6.68571 2.57143 10.4571V16.6286L0 19.1143V20.3143H20.5714V19.1143L18 
    16.6286ZM7.71429 15.6857C7.71429 15.9429 7.54286 16.1143 7.28571 16.1143H4.71429C4.45714 16.1143 4.28571 15.9429 4.28571 
    15.6857V9.25714C4.28571 9 4.45714 8.82857 4.71429 8.82857H7.28571C7.54286 8.82857 7.71429 9 7.71429 9.25714V15.6857ZM12 
    15.6857C12 15.9429 11.8286 16.1143 11.5714 16.1143H9C8.74286 16.1143 8.57143 15.9429 8.57143 15.6857V4.54286C8.57143 
    4.28571 8.74286 4.11429 9 4.11429H11.5714C11.8286 4.11429 12 4.28571 12 4.54286V15.6857ZM16.2857 15.6857C16.2857 
    15.9429 16.1143 16.1143 15.8571 16.1143H13.2857C13.0286 16.1143 12.8571 15.9429 12.8571 15.6857V7.97143C12.8571 
    7.71429 13.0286 7.54286 13.2857 7.54286H15.8571C16.1143 7.54286 16.2857 7.71429 16.2857 7.97143V15.6857Z"
    fill="white"
    fill-opacity="0.75"
  />
  <path
    d="M10.2853 23.9999C11.7424 23.9999 12.8567 22.8856 12.8567 21.5142H7.71387C7.71387 22.8856 8.82815 23.9999 10.2853 23.9999Z"
    fill="white"
    fill-opacity="0.75"
  />
</svg>
